import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
} from "react-router-dom";
import axios from "axios";
import "./App.css";

function UnsubscribePage() {
  let { id, token } = useParams();
  const [isUnsubscribed, setUnsubscribed] = useState(false);

  const handleUnsubscribe = () => {
    if (id.indexOf("--") > 0) {
      const id_token = id.split("--");
      if (id_token.length > 1) {
        id = id_token[0];
        token = id_token[1];
      }
    }

    if (window.confirm("Are you sure you want to unsubscribe?")) {
      const url = `${process.env.REACT_APP_BACKEND_HOST}/v1/conversationContacts/${id}/optout`;
      const body = { id, token };

      axios
        .patch(url, body)
        .then((response) => {
          setUnsubscribed(true);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  // This code is a React component that renders an unsubscribe button. It displays a heading and a message indicating that the user will stop receiving special product/service offers. If
  // isUnsubscribed is true, it shows a success message; otherwise, it shows an "Unsubscribe" button. When the button is clicked, it triggers the handleUnsubscribe function.
  return (
    <div className="container">
      <h1>Unsubscribe</h1>
      <p>I do not want to receive special product/service offers any more</p>
      {isUnsubscribed ? (
        <p>You have successfully unsubscribed.</p>
      ) : (
        <button onClick={handleUnsubscribe}>Unsubscribe</button>
      )}

      <small style={{ color: "#fff", bottom: "5px", position: "absolute" }}>
        Version {process.env.REACT_APP_BUILD}
      </small>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/unsubscribe/:id" element={<UnsubscribePage />} />
        <Route path="/unsubscribe/:id/:token" element={<UnsubscribePage />} />
        <Route
          path="/"
          element={
            <div className="container">
              <p>
                Welcome to Unsubscribe! Please provide the correct information:
              </p>

              <small
                style={{ color: "#fff", bottom: "5px", position: "absolute" }}
              >
                Version {process.env.REACT_APP_BUILD}
              </small>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
